import React, { useState, useEffect } from 'react'
import Link from 'react-router-dom/Link'
import { routes } from '../../../../../constants/routes.constants'
import { Partner } from '../styles.style'
import { BuyWinService } from '../../../../../services/buy-win.service'

const PartnerListComponent = () => {
	const [partners, setPartners] = useState([])

	useEffect(() => {
		BuyWinService.getListPartners().then(res => setPartners(res))
	}, [])

	return (
		<Partner className="partner-list">
			{partners.map(
				({ internalURL, externalURL, name, logo, real, point }, index) => (
					<li key={index}>
						<div className="box-partner">
							<figure>
								<a href={externalURL} target="_blank">
									<img
										src={`../assets/static/store-partner/${logo}.png`}
										alt={name}
									/>
								</a>
							</figure>
							<div className="partner-list-points">
								{point > 1 ? (
									<p>
										{real.$toReais()} = {point} pontos Muviflex
									</p>
								) : (
									<p>
										{real.$toReais()} = {point} ponto Muviflex
									</p>
								)}
							</div>
							<footer>
								<Link
									to={`${routes.CLIENTE}/compre-e-ganhe/${internalURL}`}
									className="about"
									title="Saiba Mais">
									Saiba mais
								</Link>
							</footer>
						</div>
					</li>
				)
			)}
		</Partner>
	)
}

export default PartnerListComponent
